module.exports = __webpack_public_path__ + "img/greenbackground.5c0c9934.png";